import React, { useMemo, Fragment } from "react";
import { useSelector } from "react-redux";
import TYPE from "../../../../../constant/TYPE";
import Title from "./Title";
import ClosePopup from "../popup/ClosePopup";
import ClosePopupGlobal from "../../presentationalGlobal/popup/ClosePopup";
import QuestionList from "./QuestionList";
import AnswerList from "./AnswerList";

const Header = ( props ) => {

  const user = useSelector( state => state.user );
  const answeringQuestions = useSelector( state => state.answeringQuestions );

  const {
    Closer,
    QuestionListController,
    AnswerListController
  } = props;

  const CLOSE_POPUP = useMemo( () => {
    return TYPE.CHANNEL.GLOBAL01 === user.info?.channelCode && TYPE.ENTRY_TYPE.GLOBAL01 === user.info?.entryType ? ClosePopupGlobal : ClosePopup;
  }, [ user.info?.channelCode, user.info?.entryType ] );

  return (
    <div className="header dark">
      <div className="inner">
        <div className="headerBox fuller">
          <div className="headerBox_head">
            <Title>{ answeringQuestions.data.stgNm }</Title>
            <Closer><CLOSE_POPUP><button className="btn-close-wrap">닫기</button></CLOSE_POPUP></Closer>
          </div>
          <div className="headerBox_body">
            <div className="header-qa-wrap">
              <div className="qa-cnt-wrap"><span>{ answeringQuestions.answeringCount }</span> /{ answeringQuestions.listData.length }</div>
              <QuestionListController><QuestionList /></QuestionListController>
              <AnswerListController><AnswerList /></AnswerListController>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

};

Header.defaultProps = {
  Closer : Fragment,
  QuestionListController : Fragment,
  AnswerListController : Fragment
};

export default Header;
